// Dynamic API URL - works with any domain (custom domain, preview, localhost)
const getApiBase = () => {
  // In browser, use current origin so custom domains work
  if (typeof window !== 'undefined' && window.location) {
    return window.location.origin;
  }
  return process.env.REACT_APP_BACKEND_URL || '';
};

export const API_BASE = getApiBase();
export const API = `${API_BASE}/api`;
